import React, { useState } from "react";
import CalendarHeader from "./CalendarHeader";
import CalendarGrid from "./CalendarGrid";
import TimeSelector from "./TimeSelector";

import "./Calendar.scss";

const Calendar = ({ onDateChange, onTimeChange }) => {
    const [selectedDate, setSelectedDate] = useState(new Date());
    const [selectedTime, setSelectedTime] = useState(null);
    const [currentMonth, setCurrentMonth] = useState(new Date());

    const handleDateSelect = (date) => {
        // Convertir la fecha seleccionada a UTC manualmente
        const utcDate = new Date(
            Date.UTC(date.getFullYear(), date.getMonth(), date.getDate())
        );
        setSelectedDate(utcDate);

        console.log("Fecha seleccionada (UTC):", utcDate.toISOString());

        if (onDateChange) onDateChange(utcDate.toISOString().split("T")[0]);
    };

    const handleTimeChange = (time) => {
        setSelectedTime(time);
        console.log("Hora seleccionada:", time);
        if (onTimeChange) onTimeChange(time);
    };

    return (
        <div className="calendar-container">
            <CalendarHeader
                currentMonth={currentMonth}
                setCurrentMonth={setCurrentMonth}
            />
            <CalendarGrid
                currentMonth={currentMonth}
                selectedDate={selectedDate}
                setSelectedDate={handleDateSelect}
            />
            <TimeSelector
                selectedTime={selectedTime}
                onTimeChange={handleTimeChange}
            />
        </div>
    );
};

export default Calendar;
